/*
This is a simple utility function to let selectors accept parameters.

All selectors expect the state to be the first parameter and some of ours have
additional parameters.

export const selectTerm = createSelector(
    selectTerms,
    param(1),
    (terms, id) => {
        return terms[id]
    }
)

selectTerm(state, 1)
// terms = selectTerms(state, 1)
// id = param(state, 1) // Just pick up the parameter at this index
*/
export const param = index => (...args) => args[index];



// WEBPACK FOOTER //
// ./src/selectors/utils.js